import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
    incubatorListData: [],
    totalCount: 0,
    gardenList: [],
    gardenTotal: 0,
    gardenPage: 1,
    // 页面参数
    pageData: {}
}
const mutations = {
    changeData(state, data) {
        state.incubatorListData = data;
    },
    changePage(state, total) {
        state.totalCount = total;
    },
    // 设置园区列表数据
    setGardenData(state, data) {
        state.gardenList = data.data;
        state.gardenTotal = data.total;
    },
    // 园区列表分页参数改变
    gardenPageChanged(state, data) {
        state.gardenPage = data.page;
    },
    // 设置保存页面所需参数, value(object类型)
    setPageData(state, value) {
        state.pageData = Object.assign(state.pageData, value);
    },
    // 删除无用的页面参数, key(string类型, 要删除的键名)
    deletePD_Item(state, key) {
        delete state.pageData[key];
    }
}
const pcModule = {
    state, mutations
}
const appModule = {
    state, mutations
}
export const store = new Vuex.Store({
    state,
    mutations,
    modules: {
        pc: pcModule,
        app: appModule
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js